import { useEffect, useState } from 'react';

/** Значение, которое догоняет `value` через `ms` тишины: листают дни/недели стрелками — запрос уходит за
 *  последним, а не за каждым промежуточным (Алексей 29.10 #3271). */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setV(value), ms);
    return () => window.clearTimeout(id);
  }, [value, ms]);
  return v;
}
